import React from 'react';
import { Icon } from '@material-ui/core';
import Close from '../poetstool-close-icon.svg';

export const CloseIcon = () => (
  <Icon>
    <img src={Close} height={25} width={25} alt='Close Icon' />
  </Icon>
);
